import { createRouter, createWebHistory } from "vue-router";
import requestFormLarge from "../components/requestFormLarge.vue";
import testCountryJson from "@/components/testCountryJson.vue";
import trackingForm from "@/components/trackingForm.vue";
import requestFormSmall from "@/components/requestFormSmall.vue";
import trackingData from "@/components/trackingData.vue";
import formResponse from "@/components/formResponse.vue";
import headerComponent from "@/components/headerComponent.vue";
import footerComponet from "@/components/footerComponet.vue";
import homePage from "@/components/homePage.vue";
import homepage2 from "@/components/homePage2.vue";
import homepage3 from "@/components/homePage3.vue";
import homepage4 from "@/components/homePage4.vue";
import homepage5 from "@/components/homePage5.vue";
import newFormSmall from "@/components/newFormSmall.vue";
import contactUs from "@/components/contactUs.vue";

const routes = [
  {
    path: "/header",
    component: headerComponent,
  },
  {
    path: "/contactUs",
    component: contactUs,
  },
  {
    path: "/footer",
    component: footerComponet,
  },
  {
    path: "/newFormSmall",
    component: newFormSmall,
  },
  {
    path: "/homepage",
    component: homePage,
  },
  {
    path: "/homepage2",
    component: homepage2,
  },
  {
    path: "/homepage3",
    component: homepage3,
  },
  {
    path: "/homepage4",
    component: homepage4,
  },
  {
    path: "/homepage5",
    component: homepage5,
  },
  {
    path: "/requestFormLarge",
    component: requestFormLarge,
  },
  {
    path: "/",
    component: requestFormSmall,
  },
  {
    path: "/trackingForm",
    component: trackingForm,
  },
  {
    path: "/formResponse",
    component: formResponse,
  },
  {
    path: "/testCountryJson",
    component: testCountryJson,
  },
  {
    path: "/trackingData",
    component: trackingData,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
